import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import React from 'react';
import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import { ReceiptLineItem } from 'src/components/selfService/features/OrderHistory/ReceiptLineItem/ReceiptLineItem';
import { FeeType, IOrdersReceipt } from 'src/types/OrderHistory';

export interface ICampaignFeeLineItemProps {
  order: IOrdersReceipt;
  feeAmount: number;
  campaignFeeType: FeeType;
  title: string;
}

export function FeeLineItem({
  order,
  feeAmount,
  campaignFeeType,
  title,
}: ICampaignFeeLineItemProps): JSX.Element | null {
  const campaignFeeDisplayText = get(
    order,
    'savings_breakdown',
    'fee_savings',
    campaignFeeType,
    'display_text'
  );

  if (!feeAmount) {
    return null;
  }

  return (
    <ReceiptLineItem
      title={title}
      amount={formatPenniesToCurrency(feeAmount)}
      newAmount={campaignFeeDisplayText}
    />
  );
}
